module.exports = __webpack_public_path__ + "static/media/disney-hulu.4c1c5606.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/disney-hulu.png
// module id = 7359
// module chunks = 4